module.exports = __webpack_public_path__ + "img/bank.dd2265b7.png";